import React, { useEffect, useState } from "react";

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SettingsModal({ isOpen, onClose }: SettingsModalProps) {
  const [darkMode, setDarkMode] = useState<boolean>(() => {
    if (typeof window !== 'undefined') {
      return document.documentElement.classList.contains('dark');
    }
    return false;
  });

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
      <div className="text-black bg-uiBackground rounded-lg p-8 min-w-[300px] shadow-lg">
        <h2 className="text-2xl font-bold">Settings</h2>
        <div className="flex text-md font-medium items-center justify-between ml-4 mt-4">
          <span>Theme</span>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={darkMode}
              onChange={() => setDarkMode((prev) => !prev)}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-chatBackground-light peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-primary-light dark:peer-focus:ring-primary-dark rounded-full peer dark:bg-chatBackground-dark transition-colors duration-200"></div>
            <div className="absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform duration-200 peer-checked:translate-x-5"></div>
            <span className="ml-2">
              {darkMode ? 'Dark' : 'Light'}
            </span>
          </label>
        </div>
        <button
          onClick={onClose}
          className="px-4 py-2 rounded text-white font-semibold mt-8 bg-primary-light dark:bg-primary-dark hover:bg-secondary-dark dark:hover:bg-secondary-light"
        >
          Close
        </button>
      </div>
    </div>
  );
}
